var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { NotificationsRepository } from 'packages/notifications/NotificationsRepository';
import { Cursoring } from 'packages/core/Cursoring';
import { NotificationsAggregate, NotificationsAggregator } from 'packages/notifications/NotificationsAggregator';
import Vue from 'vue';
import NotificationDrawerAggregate from 'ui/v1/notifications/NotificationDrawerAggregate.vue';
import Icon from 'common/UIToolKit/Icon.vue';
import LoaderBox from 'common/UIToolKit/layout/LoaderBox.vue';
import Filters from '../../components/notifications/Filters.vue';
import EmptyState from 'ui/v1/EmptyState.vue';
import HistoryNotificationTranslation from '@/app/views/notifications/HistoryNotificationTranslation.vue';
var HistoryView = /** @class */ (function (_super) {
    __extends(HistoryView, _super);
    function HistoryView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notificationsRepository = new NotificationsRepository();
        _this.cursoring = new Cursoring();
        _this.notifications = [];
        _this.filteredNotifications = [];
        _this.aggregator = new NotificationsAggregator();
        _this.loading = false;
        _this.allNotificationTranslationKeys = [
            'new_talent_1',
            'new_talent_2',
            'new_talent_many',
            'talent_moved_1',
            'talent_moved_2',
            'talent_moved_many',
            'inbound_email_1',
            'inbound_email_2',
            'inbound_email_many',
            'talent_comment_1',
            'talent_comment_2',
            'talent_comment_many',
        ];
        _this.scrollListener = function (event) {
            var element = event.target;
            // we start loading a bit before the user reaches the bottom
            // to avoid flashing the load button
            if (element.documentElement.scrollHeight - element.documentElement.scrollTop - element.documentElement.clientHeight <= 50) {
                _this.loadNewNotificationsIfPossible();
            }
        };
        return _this;
    }
    Object.defineProperty(HistoryView.prototype, "allNotificationsLoaded", {
        get: function () {
            return this.notifications.length === this.cursoring.total;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HistoryView.prototype, "groupedNotifications", {
        get: function () {
            return this.aggregator.byDay(this.filteredNotifications);
        },
        enumerable: false,
        configurable: true
    });
    HistoryView.prototype.created = function () {
        this.cursoring.limit = 50;
    };
    HistoryView.prototype.mounted = function () {
        document.addEventListener('scroll', this.scrollListener);
        this.loadNotifications();
    };
    HistoryView.prototype.beforeDestroy = function () {
        document.removeEventListener('scroll', this.scrollListener);
    };
    HistoryView.prototype.loadNewNotificationsIfPossible = function () {
        if (this.loading || !this.cursoring.cursor) {
            return;
        }
        this.loadNotifications();
    };
    HistoryView.prototype.loadNotifications = function () {
        var _this = this;
        this.loading = true;
        this.notificationsRepository
            .list(this.cursoring.cursor, this.cursoring.limit)
            .then(function (response) {
            _this.cursoring.total = response.pagination.total;
            if (response.items.length === 0) {
                return;
            }
            _this.filteredNotifications = _this.notifications;
            _this.notifications = _this.notifications.concat(response.items);
            _this.cursoring.cursor = response.cursor;
        })
            .finally(function () { return _this.loading = false; });
    };
    HistoryView.prototype.dayHeading = function (day) {
        var heading = '';
        if (day.unreadCount > 0) {
            heading = day.unreadCount + " " + this.$t('notifications.unread') + ", ";
        }
        return "" + heading + day.notifications.length + " " + this.$t('notifications.total');
    };
    HistoryView.prototype.toAggregate = function (notification) {
        var aggregate = new NotificationsAggregate(notification.data.jobId, notification.event);
        aggregate.notifications.push(notification);
        return aggregate;
    };
    HistoryView.prototype.setFilteredNotifications = function (filteredNotifications) {
        this.filteredNotifications = filteredNotifications;
    };
    HistoryView = __decorate([
        Component({
            components: {
                EmptyState: EmptyState,
                Filters: Filters,
                LoaderBox: LoaderBox,
                Icon: Icon,
                NotificationDrawerAggregate: NotificationDrawerAggregate,
                HistoryNotificationTranslation: HistoryNotificationTranslation,
            },
        })
    ], HistoryView);
    return HistoryView;
}(Vue));
export default HistoryView;
